import { jsx } from "react/jsx-runtime";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { validateTidalLicense } from "../../base/index.js";
function VpnKey(props) {
  return /* @__PURE__ */ jsx(
    VpnKeyIcon,
    {
      "data-testid": "VpnKey",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "VpnKey",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
VpnKey.tidalIconMeta = {
  categories: "miscellaneous",
  name: "VpnKey"
};
validateTidalLicense();
export {
  VpnKey
};
//# sourceMappingURL=VpnKey.js.map
